import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import WhatsappIcon from 'public/img/logowhatsapp-icon.svg'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import sx from './styles'

const EasyWhatsappLink = ({ onClickWhatsapp }) => {
  return (
    <Box sx={sx.main}>
      <Button
        rel="noopener noreferrer"
        variant="text"
        onClick={onClickWhatsapp}
        style={{ marginRight: '4px' }}
      >
        <Typography
          variant="body2"
          sx={sx.title}
        >
          <FormattedMessage
            id="EASY_WHASTAPP_MESSAGE"
          />

        </Typography>
      </Button>
      <WhatsappIcon sx={sx.icon} />
    </Box>
  )
}

export default memo(EasyWhatsappLink)
